import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import { find } from '../utils/dom';

const initializeSwiperVideosBlog = () => {
  const section = document.querySelector("#section-videos-blog");
  if (!section) return;

  const swiperContainer = section.querySelector(".mySwiperVideosBlog");
  const swiperWrapper = swiperContainer.querySelector(".swiper-wrapper");
  const filtroLinks = section.querySelectorAll('#swiper-videos-blog a[data-filter], #swiper-videos-blog a[href*="?categoria="]');
  const btnNext = section.querySelector(".swiper-button-next-videos-blog");
  const btnPrev = section.querySelector(".swiper-button-prev-videos-blog");

  const $config = {
    numeracao: find(".swiper-numeracao-videos-blog-ativo"),
    setNumeracao: (_n) => {
      $config.numeracao.innerText = (_n < 10) ? "0" + _n : _n;
    },
    numeracaoTotal: find(".swiper-numeracao-videos-blog-total"),
    setNumeracaoTotal: (_total) => {
      $config.numeracaoTotal.innerText = (_total < 10) ? "0" + _total : _total;
    },
  };

  let swiper;
  let slidesOriginais = [];

  function clonarSlidesOriginais() {
    const allSlides = Array.from(section.querySelectorAll('.swiper-slide[data-categoria]'));
    slidesOriginais = allSlides.map(slide => slide.cloneNode(true));
  }

  function initSwiper(slidesVisiveis) {
    if (swiper) swiper.destroy(true, true);
    swiperWrapper.innerHTML = '';
    slidesVisiveis.forEach(slide => swiperWrapper.appendChild(slide));

    swiper = new Swiper(swiperContainer, {
      slidesPerView: "auto",
      slidesPerGroup: 1,
      spaceBetween: 24,
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },
      pagination: {
        el: ".swiper-pagination-videos-blog",
        clickable: true,
      },
      breakpoints: {
        1280: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
        640: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
      },
      on: {
        init: function () {
          const totalBarras = document.querySelectorAll(".swiper-pagination-videos-blog .swiper-pagination-bullet").length;
          $config.setNumeracaoTotal(totalBarras);
          $config.setNumeracao(1);
        },
        slideChange: function () {
          const activeBullet = document.querySelector(".swiper-pagination-videos-blog .swiper-pagination-bullet.swiper-pagination-bullet-active");
          if (!activeBullet) return;

          const index = [...activeBullet.parentElement.children].indexOf(activeBullet) + 1;
          $config.setNumeracao(index);
        },
        resize: function () {
          const totalBarras = document.querySelectorAll(".swiper-pagination-videos-blog .swiper-pagination-bullet").length;
          $config.setNumeracaoTotal(totalBarras);
        }
      }
    });
  }

  function filtrarSlides(categoriaId) {
    const slidesFiltrados = slidesOriginais.filter(slide => {
      const categorias = slide.dataset.categoria?.split(',') || [];
      return categoriaId === 'todos' || categorias.includes(categoriaId);
    }).map(slide => slide.cloneNode(true));

    initSwiper(slidesFiltrados);
  }

  filtroLinks.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();

      filtroLinks.forEach(l => {
        l.classList.remove('bg-primary-pure', 'text-black');
        l.classList.add('text-white/60');
      });

      link.classList.add('bg-primary-pure', 'text-black');
      link.classList.remove('text-white/60');

      let categoriaSelecionada = link.dataset.filter || null;
      if (!categoriaSelecionada && link.href) {
        const url = new URL(link.href, location.origin);
        categoriaSelecionada = url.searchParams.get('categoria');
      }

      if (!categoriaSelecionada) categoriaSelecionada = 'todos';

      filtrarSlides(categoriaSelecionada);
    });
  });

  // Inicialização inicial
  clonarSlidesOriginais();
  initSwiper(slidesOriginais.map(slide => slide.cloneNode(true)));

  // Atualiza ao redimensionar
  window.addEventListener('resize', () => {
    if (!swiper) return;
    const slidesAtuais = Array.from(swiperWrapper.querySelectorAll('.swiper-slide'));
    initSwiper(slidesAtuais.map(slide => slide.cloneNode(true)));
  });
};

export default initializeSwiperVideosBlog;
